<template>
  <div id="app">
    <navbar></navbar>
    <router-view />
    <foot></foot>
    <toast></toast>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Toast from "@/components/Toast.vue";
import { auth } from '@/store/firebase.js';

export default {
  data() {
    return {};
  },
  components: {
    navbar: Header,
    foot: Footer,
    toast: Toast
  },
  mounted: function() {
    this.$store.dispatch("getArticles");
    auth.onAuthStateChanged(user => {
      if(user) {
        this.$store.commit("LOGIN");
      }
    })
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
